export const BRANCH_ACTION_PROMOTION_PAGE = 'searchPromoProducts'
export const BRANCH_ACTION_LANDING_PAGE = 'goToLandingPage'
export const BRANCH_ACTION_PDP_PAGE = 'goToPDP'
export const BRANCH_ACTION_CHANGE_STORE = 'goToStore'
export const BRANCH_ACTION_MEMBERSHIP = 'membership'
export const BRANCH_ACTION_PLAN = 'plan'
export const BRANCH_ACTION_STORES = 'stores'
export const BRANCH_ACTION_MANUAL_RESCHEDULE = 'goToRescheduleBanner'
export const BRANCH_ACTION_MANUAL_RESCHEDULE_ORDER = 'goToRescheduledOrder'
export const BRANCH_ACTION_GO_TO_CART = 'goToCart'
export const BRANCH_ACTION_ORDER_PROGRESS = 'goToOrderProgress'
export const BRANCH_ACTION_SEARCH_PRODUCTS = 'searchProducts'
export const BRANCH_ACTION_GO_TO_SEARCH = 'goToSearch'
export const BRANCH_ACTION_GO_TO_SEARCH_QUERY = 'goToSearchQuery'
